import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'x-settings-section',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './x-settings-section.component.html',
  styleUrl: './x-settings-section.component.scss',
})
export class XSettingsSectionComponent {
  title = input.required<string>();
}
